import { hide, show, success, error, notice, help, loading } from './func';
import Message from './message';
import './styles/index.scss';
const ExpandedMessage = Message;
ExpandedMessage.show = show;
ExpandedMessage.hide = hide;
ExpandedMessage.success = success;
ExpandedMessage.error = error;
ExpandedMessage.notice = notice;
ExpandedMessage.help = help;
ExpandedMessage.loading = loading;
export default ExpandedMessage;
